import React from "react";

import { Box, Title } from "@allxsmith/bestax-bulma";
import ContactSection from "../Contact/ContactSection";

function CustomerOwnerSection(props) {
  return (
    <Box>
      <details>
          <summary><Title>Customer Owner Info</Title></summary>
      <ContactSection
        title="Customer"
        contactUpdate={customer => props.onChange({target: {name: 'owner', value: customer}})}
        endpoint={props.endpoint + "contacts"}
        contact={props.data.owner || {}}
        type="CC"
        showDeactivated={true}
      />
      </details>
    </Box>
  );
}

export default CustomerOwnerSection;
